module.exports = "/_next/static/images/icon-mobile-download-60625238.png";